<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-12-23 14:13:02
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-02-02 13:23:10
-->
<template>
  <div>
    <div class="agreement">
      <i
        class="iconfont select"
        v-bind:class="{
          'icon-weigouxuan':
            this.$store.state.commonForms.agreeWithAgreement === 0,
          'icon-gouxuanxieyi-icon- seletedColor':
            this.$store.state.commonForms.agreeWithAgreement === 1,
        }"
        @click="clickAgree()"
      ></i><span @click="clickAgree()">本人已经阅读并完全同意：</span>
      <span @click="show(item.value)" v-for="item in list" :key="item.value"
        >《{{ item.text }}》</span
      >
    </div>
  </div>
</template>
<script>
export default {
  name: 'Contract',
  props: ['model', 'columnsTerm'],
  data() {
    return {
      list: JSON.parse(localStorage.getItem('contractMap')) || [],
    };
  },
  mounted() {
  },
  methods: {
    clickAgree() {
      this.$emit('agree');
    },
    show(val) {
      const agreeMap = {
        bw_sq: 'EnterpriseAuthorizationAgreement',
        dashu_h5: 'DashuH5',
        pds_sq: 'PersonalAuthorizedAgreement',
        pds_invoice: 'InformationCheckAndUseAgreement',
        spdb_pi: 'PufaOnlineAuth',
        spdb_uspec: 'PufaStatementUse',
        spdb_guarantee: 'GuaranteeServiceContract',
      };
      this.$emit('showPopup', agreeMap[val]);
    },
  },
};
</script>
<style scoped>
.agreement {
  box-sizing: border-box;
  margin-top: 10px;
  padding-left: 15px;
  color: #80848f;
  font-size: 14px;
  line-height: 30px;
  letter-spacing: 0;
  text-align: left;
}
.agreement span {
  color: #0079cc;
}
.select {
  margin-right: 5px;
}
.seletedColor {
  color: #ff6538;
}
</style>
